import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'LM',
  name: 'L.M.',
  role: 'Research Methods Teacher · International Baccalaureate School',
  text: '“I no longer spend my Sunday nights building research sequences from scratch. I open the system, choose the lesson and walk in completely prepared. My students understand the process with a clarity that used to take me weeks to achieve — and I feel it too.”'
}, {
  initials: 'PR',
  name: 'P.R.',
  role: 'Introductory College Research Instructor',
  text: '“The emergency lessons saved me four times in the first month alone. That resource is worth the full price by itself.”'
}, {
  initials: 'CV',
  name: 'C.V.',
  role: 'High School Research Methods Teacher',
  text: '“The progression of the 120 lessons changed how I explain every stage of the research process. My explanations are clearer, my students move faster and I do not waste a single minute designing activities from scratch.”'
}];
export function TestimonialsStrip() {
  return <section className="py-12 border-y border-navy-border bg-navy-card" data-id="element-202" data-mp="gdj7kpi4co8a">
      <div className="max-w-7xl mx-auto px-4" data-id="element-203" data-mp="ldnnadb7dexg">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-204" data-mp="lbuf2tkxymnc">
          {testimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-black border border-gold/20 p-6 rounded-2xl relative" data-id="element-205" data-mp="q5f43w4k46ae" data-mpi={index}>
              <div className="flex gap-1 text-gold mb-4" aria-label="5 out of 5 stars" data-id="element-206" data-mp="192q5pndnvbt0">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-207" data-mp="35wbe1541h9ej" data-mpi={starIndex} />)}
              </div>
              <p className="text-gray-300 italic mb-6 text-sm leading-relaxed" data-id="element-208" data-mp="3atjpkmuomf6t">{testimonial.text}</p>
              <div className="flex items-center gap-3" data-id="element-209" data-mp="hz31rpdxaacr">
                <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold flex items-center justify-center text-gold font-bold" data-id="element-210" data-mp="i1pfk6repm3f">
                  {testimonial.initials}
                </div>
                <div data-id="element-211" data-mp="m1g3m2pjto49">
                  <div className="font-bold text-white text-sm" data-id="element-212" data-mp="m0y9bbmg5jyz">{testimonial.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-213" data-mp="10ygygf31dz6y">{testimonial.role}</div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}